<div class="modal-header">
  <h4 class="modal-title" id="modal-subscribers-title">{{isRCDSS ? 'Notification Settings' : 'Subscribers'}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ngx-po-subscribers
    *ngIf="purchaseOrder?.id"
    [companyType]="'customer'"
    [supplierId]="purchaseOrder.supplier_id"
    [(purchaseOrder)]="purchaseOrder"
    [(subscribers)]="subscribers"
    [isCreationMode]="true"
  ></ngx-po-subscribers>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary text-white" (click)="activeModal.close(subscribers)">Finish</button>
</div>
